import React from 'react';

const AreaPicker = ({ occasionBooking, selectedDay, selectedMonth, selectedYear, selectedHour, selectedMinute, numberOfGuests, areas, selectedArea, onChange }) => {

    const getAreas = () => {
        if (areas) {
            let areaNameList = [];
            areas.forEach(area => {
                if (!!occasionBooking?.liveresId) {
                    if(area.id === occasionBooking.liveresId && area.areaLinkGroup.areaLinks[0]?.name && area.name.toLowerCase().indexOf('enquiry') == -1 && area.name.toLowerCase().indexOf('table') == -1) {
                        areaNameList.push(area.areaLinkGroup.areaLinks[0].name); 
                    }
                } else {
                    if (area.areaLinkGroup.areaLinks[0]?.name && area.name.toLowerCase().indexOf('enquiry') == -1 && area.name.toLowerCase().indexOf('table') == -1) {
                            areaNameList.push(area.areaLinkGroup.areaLinks[0].name);
                    }
                }                
            });
            return areaNameList;
        }

        return [];

    }

    const handleAreaChange = (e) => {
        onChange(areas, e.target.value === "-" ? "" : e.target.value);
    }

    if(getAreas().length === 0){ 
        return <React.Fragment></React.Fragment>;
    }
    else {
        return (
            <React.Fragment>
                <label className='label'>Preferred area of the restaurant</label>
                <div className="question-dropdown">
                    <div className="question">
                        <select value={selectedArea?.areaLinkGroup?.areaLinks[0]?.name ?? "-"} className="select question-dropdown-select w-full" onChange={handleAreaChange}>
                            <option key="areaDefault">Select an area</option>
                            {getAreas().map((a, i) => (
                                <option key={i}>{a}</option>
                            ))}
                        </select>
                    </div>
                    <p className="field-info">
                        If you book a table outside and it rains on the day, we may not be able to move you inside if we're fully booked.
                    </p>
                </div>
            </React.Fragment>
        );
    }

}

export default AreaPicker;